import React, { useState, useEffect } from 'react';
import styles from './EmpreendimentoForm.module.css';

const API_URL = `${import.meta.env.VITE_URL_API}/usuarios-empreendimento/criar`;

const EmpreendimentoForm = ({ onBack }) => {
  const [showCorrespondenceAddress, setShowCorrespondenceAddress] = useState(false);
  const [showProfessionalHQAddress, setShowProfessionalHQAddress] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    nomeUSUARIO: '',
    sobrenomeUSUARIO: '',
    emailUSUARIO: '',
    senhaUSUARIO: '',
    termoecondicoesUSUARIO: false,
    facebookidUSUARIO: '',
    appleidUSUARIO: '',
    googleidUSUARIO: '',
    country: '',
    contactName: '',
    contactDDD: '',
    contactPhone: '',
    contactDDDConfirm: '',
    contactPhoneConfirm: '',
    showJoviPlanetContact: false,
    joviPlanetContactEmail: ''
  });
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${import.meta.env.VITE_URL_API}/paises`)
      .then(res => res.json())
      .then(data => setCountries(data))
      .catch(() => setCountries([]));
  }, []);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);
    try {
      // Montar payload conforme esperado pela API
      const payload = {
        nomeUSUARIO: form.nomeUSUARIO,
        sobrenomeUSUARIO: form.sobrenomeUSUARIO,
        emailUSUARIO: form.emailUSUARIO,
        senhaUSUARIO: form.senhaUSUARIO,
        termoecondicoesUSUARIO: form.termoecondicoesUSUARIO,
        facebookidUSUARIO: form.facebookidUSUARIO,
        appleidUSUARIO: form.appleidUSUARIO,
        googleidUSUARIO: form.googleidUSUARIO,
        paisUSUARIO: form.country,
        licencaUSUARIO: form.licencaUSUARIO,
        nomeempresaUSUARIO: form.companyName,
        nif: form.nif,
      
        // Endereço Fiscal (sempre obrigatório)
        ruaenumeroUSUARIO: form.fiscalAddress,
        codigopostalUSUARIO: form.postalCode,
        freguesiaUSUARIO: form.parish,
      
        // Endereço de Correspondência (usa fiscal se toggle desligado)
        ruaenumero1USUARIO: showCorrespondenceAddress ? form.hqAddress : form.fiscalAddress,
        codigopostal1USUARIO: showCorrespondenceAddress ? form.hqPostalCode : form.postalCode,
        freguesia1USUARIO: showCorrespondenceAddress ? form.hqParish : form.parish,
      
        // Sede do Profissional (usa fiscal se toggle desligado)
        ruaenumero2USUARIO: showProfessionalHQAddress ? form.hqAddress : form.fiscalAddress,
        codigopostal2USUARIO: showProfessionalHQAddress ? form.hqPostalCode : form.postalCode,
        freguesia2USUARIO: showProfessionalHQAddress ? form.hqParish : form.parish,
      
        // Outros campos... 
        prefixoUSUARIO: form.contactDDD,
        numeroprincipalUSUARIO: form.contactPhone,
        prefixo1USUARIO: form.contactDDDConfirm,
        numeroprincipal1USUARIO: form.contactPhoneConfirm,

      };
      console.log('Payload enviado:', payload);
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        setSuccess(true);
        setForm({
          nomeUSUARIO: '',
          sobrenomeUSUARIO: '',
          emailUSUARIO: '',
          senhaUSUARIO: '',
          termoecondicoesUSUARIO: false,
          facebookidUSUARIO: '',
          appleidUSUARIO: '',
          googleidUSUARIO: '',
          country: ''
        });
      } else {
        const data = await response.json();
        setError(data.message || 'Erro ao cadastrar.');
      }
    } catch (err) {
      setError('Erro ao conectar à API.');
    }
    setLoading(false);
  };

  return (
    <div className={styles['register-professional-form']}>
      <h2 className={styles['form-title']}>Registro de empreendimento</h2>
      {success && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.35)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'fadeIn 0.4s'
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 18,
            padding: '48px 36px',
            minWidth: 340,
            boxShadow: '0 8px 48px rgba(0,0,0,0.18)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 18,
            position: 'relative',
            animation: 'popIn 0.3s'
          }}>
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none"><circle cx="32" cy="32" r="32" fill="#2ecc71"/><path d="M18 34l10 10 18-18" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg>
            <h2 style={{margin: '20px 0 0 0', color: '#2ecc71', fontWeight: 800, fontSize: 28, textAlign: 'center'}}>Cadastro realizado com sucesso!</h2>
            <p style={{color: '#444', fontSize: 18, textAlign: 'center', margin: 0}}>Seja bem-vindo à JoviPlanet!</p>
            <button onClick={() => setSuccess(false)} style={{marginTop: 16, background: '#2ecc71', color: '#fff', border: 'none', borderRadius: 8, fontSize: 18, padding: '10px 32px', cursor: 'pointer', fontWeight: 700, boxShadow: '0 2px 8px rgba(44,204,113,0.12)'}}>Fechar</button>
          </div>
          <style>{`
            @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
            @keyframes popIn { 0% { transform: scale(0.8); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
          `}</style>
        </div>
      )}
      {error && <div className={styles['error-message']}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <h3>Dados da conta</h3>
          <div className={styles['form-group']}>
            <label>Nome *</label>
            <input type="text" name="nomeUSUARIO" className={styles['form-input']} placeholder="Nome" required value={form.nomeUSUARIO} onChange={handleChange} />
          </div>
          <div className={styles['form-group']}>
            <label>Sobrenome *</label>
            <input type="text" name="sobrenomeUSUARIO" className={styles['form-input']} placeholder="Sobrenome" required value={form.sobrenomeUSUARIO} onChange={handleChange} />
          </div>
          <div className={styles['form-group']}>
            <label>Email *</label>
            <input type="email" name="emailUSUARIO" className={styles['form-input']} placeholder="Email" required value={form.emailUSUARIO} onChange={handleChange} />
          </div>
          <div className={styles['form-group']}>
            <label>Senha *</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="senhaUSUARIO"
                className={styles['form-input']}
                placeholder="Senha"
                required
                minLength={9}
                value={form.senhaUSUARIO}
                onChange={handleChange}
                autoComplete="new-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                style={{
                  position: 'absolute',
                  right: 10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0
                }}
                tabIndex={-1}
                aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
              >
                {showPassword ? (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6B3F1D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-5 0-9.27-3.11-11-7.5a11.4 11.4 0 0 1 5.17-5.61"/><path d="M1 1l22 22"/><path d="M9.53 9.53A3.5 3.5 0 0 0 12 15.5a3.5 3.5 0 0 0 3.5-3.5c0-.67-.19-1.29-.53-1.82"/></svg>
                ) : (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6B3F1D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="12" rx="10" ry="7"/><circle cx="12" cy="12" r="3"/></svg>
                )}
              </button>
            </div>
            <span className={styles['password-hint']}>Use no mínimo 9 caracteres</span>
          </div>
          
        </div>
        <div className="form-section">
          <h3>Dados da empresa</h3>
          <div className={styles['form-group']}>
            <label>Designação fiscal *</label>
            <input type="text" name="companyName" className={styles['form-input']} placeholder="Designação fiscal" required value={form.companyName || ''} onChange={handleChange} />
          </div>
          <div className={styles['form-group']}>
            <label>Número da licença (se tiver uma)</label>
            <input type="text" name="license" className={styles['form-input']} placeholder="Número da licença" value={form.license || ''} onChange={handleChange} />
          </div>
          <div className={styles['form-group']}>
            <label>NIF *</label>
            <input type="text" name="nif" className={styles['form-input']} placeholder="NIF" required value={form.nif || ''} onChange={handleChange} />
          </div>
          </div>
          <div className="form-section">
          <h3>Endereço Fiscal</h3>
          
          <div className={styles['form-group']}>
            <label>Rua e número da casa*</label>
            <input type="text" name="fiscalAddress" className={styles['form-input']} placeholder="Rua e nome da rua" required value={form.fiscalAddress} onChange={handleChange} />
          </div>
          <div className={styles['form-group']}>
            <label>Código postal *</label>
            <input type="text" name="postalCode" className={styles['form-input']} placeholder="Código postal" required value={form.postalCode} onChange={handleChange} />
          </div>
          <div className={styles['form-row']}>
            <div className={styles['form-group']}>
              <label>Freguesia *</label>
              <input type="text" name="parish" className={styles['form-input']} placeholder="Freguesia" required value={form.parish} onChange={handleChange} />
            </div>
          </div>
          <div className={styles['form-group']}>
            <label>País *</label>
            <select
              name="country"
              className={styles['form-input']}
              required
              value={form.country || ''}
              onChange={handleChange}
            >
              <option value="" disabled>Selecione o país</option>
              {countries.map((pais) => (
                <option key={pais.codigoPAIS} value={pais.codigoPAIS}>{pais.nomePAIS}</option>
              ))}
            </select>
          </div>
          <div className={styles['form-group']}>
 
</div>
<div className={styles['form-group']}>
            <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:8}}>
  <label style={{ fontWeight: 700, color: '#6B3F1D', fontSize: '1.1rem', margin:0 }}>Endereço de Correspondência</label>
  <label className={styles['form-group'] + ' ' + styles['switch']} style={{margin:0}}>
    <input
      type="checkbox"
      checked={showCorrespondenceAddress}
      onChange={() => setShowCorrespondenceAddress(v => !v)}
      style={{width:22,height:22}}
    />
    <span className={styles['slider']}></span>
  </label>
  <span style={{fontSize:'1rem',color:'#6B3F1D'}}>O endereço para correspondência é diferente do endereço da empresa</span>
</div>
{showCorrespondenceAddress && ( 
  <div style={{ background: '#f8f3e6', borderRadius: 8, padding: 18, marginTop: 12 }}>
              <div className={styles['form-group']}>
                <label>Designação fiscal *</label>
                <input type="text" name="hqCompanyName" className={styles['form-input']} placeholder="Designação fiscal" required value={form.hqCompanyName || ''} onChange={handleChange} />
              </div>
              <div className={styles['form-group']}>
                <label>Rua e número da casa *</label>
                <input type="text" name="hqAddress" className={styles['form-input']} placeholder="Rua e número" required value={form.hqAddress || ''} onChange={handleChange} />
              </div>
              <div className={styles['form-row']}>
                <div className={styles['form-group']}>
                  <label>Código postal *</label>
                  <input type="text" name="hqPostalCode" className={styles['form-input']} placeholder="Código postal" required value={form.hqPostalCode || ''} onChange={handleChange} />
                </div>
                <div className={styles['form-group']}>
                  <label>Freguesia *</label>
                  <input type="text" name="hqParish" className={styles['form-input']} placeholder="Freguesia" required value={form.hqParish || ''} onChange={handleChange} />
                </div>
              </div>
            </div>
           )}

</div>
          <div className={styles['form-group']}>
  <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:8}}>
    <label style={{ fontWeight: 700, color: '#6B3F1D', fontSize: '1.1rem', margin:0 }}>Sede do Profissional</label>
    <label className={styles['form-group'] + ' ' + styles['switch']} style={{margin:0}}>
      <input
        type="checkbox"
        checked={showProfessionalHQAddress}
        onChange={() => setShowProfessionalHQAddress(v => !v)}
        style={{width:22,height:22}}
      />
      <span className={styles['slider']}></span>
    </label>
    <span style={{fontSize:'1rem',color:'#6B3F1D'}}>O endereço da sede da empresa é diferente do endereço da empresa</span>
  </div>
  {showProfessionalHQAddress && (
    <div style={{ background: '#f8f3e6', borderRadius: 8, padding: 18, marginTop: 12 }}>
              <div className={styles['form-group']}>
                <label>Designação fiscal *</label>
                <input type="text" name="hqCompanyName" className={styles['form-input']} placeholder="Designação fiscal" required value={form.hqCompanyName || ''} onChange={handleChange} />
              </div>
              <div className={styles['form-group']}>
                <label>Rua e número da casa *</label>
                <input type="text" name="hqAddress" className={styles['form-input']} placeholder="Rua e número" required value={form.hqAddress || ''} onChange={handleChange} />
              </div>
              <div className={styles['form-row']}>
                <div className={styles['form-group']}>
                  <label>Código postal *</label>
                  <input type="text" name="hqPostalCode" className={styles['form-input']} placeholder="Código postal" required value={form.hqPostalCode || ''} onChange={handleChange} />
                </div>
                <div className={styles['form-group']}>
                  <label>Freguesia *</label>
                  <input type="text" name="hqParish" className={styles['form-input']} placeholder="Freguesia" required value={form.hqParish || ''} onChange={handleChange} />
                </div>
              </div>
            </div>
         
        )} </div>
          <div style={{ background: '#f8f3e6', borderRadius: 8, padding: 24, marginTop: 24 }}>
            <h3 style={{margin: 0, marginBottom: 18, fontWeight: 700, fontSize: '1.2rem'}}>Contacto para ofertas</h3>

            <div className={styles['form-group']}>
              <label>Número de telefone principal *</label>
              <div style={{display: 'flex', gap: 0, alignItems: 'stretch'}}>
  <input
    type="text"
    value="+55"
    readOnly
    tabIndex={-1}
    style={{
      width: 50,
      background: '#f4f4f4',
      border: '1px solid #e0e0e0',
      borderRadius: '6px 0 0 6px',
      color: '#222',
      fontWeight: 600,
      fontFamily: 'Arial, sans-serif',
      fontSize: 16,
      textAlign: 'center',
      pointerEvents: 'none',
      height: 44,
      boxSizing: 'border-box'
    }}
  />
  <select
    name="contactDDD"
    value={form.contactDDD || ''}
    onChange={handleChange}
    style={{
      width: 60,
      border: '1px solid #e0e0e0',
      borderLeft: 'none',
      borderRadius: 0,
      fontSize: 16,
      fontWeight: 600,
      textAlign: 'center',
      outline: 'none',
      background: '#f4f4f4',
      color: '#222',
      appearance: 'none',
      height: 44,
      boxSizing: 'border-box'
    }}
    required
  >
                  <option value="">DDD</option>
                  <option value="11">11</option>
                  <option value="21">21</option>
                  <option value="31">31</option>
                  <option value="41">41</option>
                  <option value="51">51</option>
                  <option value="61">61</option>
                  <option value="71">71</option>
                  <option value="81">81</option>
                  <option value="91">91</option>
                </select>
                <input
    type="text"
    name="contactPhone"
    className={styles['form-input']}
    style={{
      borderRadius: '0 6px 6px 0',
      borderLeft: 'none',
      flex: 1,
      height: 44,
      boxSizing: 'border-box'
    }}
    required
    value={form.contactPhone || ''}
    onChange={handleChange}
    placeholder="Número de telefone"
  />
              </div>
            </div>
            <div className={styles['form-group']}>
              <label>Confirme o seu número de telefone principal</label>
              <div style={{display: 'flex', gap: 0, alignItems: 'stretch'}}>
  <input
    type="text"
    value="+55"
    readOnly
    tabIndex={-1}
    style={{
      width: 50,
      background: '#f4f4f4',
      border: '1px solid #e0e0e0',
      borderRadius: '6px 0 0 6px',
      color: '#222',
      fontWeight: 600,
      fontFamily: 'Arial, sans-serif',
      fontSize: 16,
      textAlign: 'center',
      pointerEvents: 'none',
      height: 44,
      boxSizing: 'border-box'
    }}
  />
  <select
    name="contactDDDConfirm"
    value={form.contactDDDConfirm || ''}
    onChange={handleChange}
    style={{
      width: 60,
      border: '1px solid #e0e0e0',
      borderLeft: 'none',
      borderRadius: 0,
      fontSize: 16,
      fontWeight: 600,
      textAlign: 'center',
      outline: 'none',
      background: '#f4f4f4',
      color: '#222',
      appearance: 'none',
      height: 44,
      boxSizing: 'border-box'
    }}
    required
  >
                  <option value="">DDD</option>
                  <option value="11">11</option>
                  <option value="21">21</option>
                  <option value="31">31</option>
                  <option value="41">41</option>
                  <option value="51">51</option>
                  <option value="61">61</option>
                  <option value="71">71</option>
                  <option value="81">81</option>
                  <option value="91">91</option>
                </select>
                <input
    type="text"
    name="contactPhoneConfirm"
    className={styles['form-input']}
    style={{
      borderRadius: '0 6px 6px 0',
      borderLeft: 'none',
      flex: 1,
      height: 44,
      boxSizing: 'border-box'
    }}
    required
    value={form.contactPhoneConfirm || ''}
    onChange={handleChange}
    placeholder="Número de telefone"
  />
              </div>
            </div>
            </div>
            <h3 style={{marginTop:24,marginBottom:12,fontWeight:700, fontSize: '1.2rem'}}>Contacto para funcionários da JoviPlanet</h3>
            <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:12}}>
              <label className={styles['form-group'] + ' ' + styles['switch']} style={{margin:0}}>
                <input
                  type="checkbox"
                  checked={form.showJoviPlanetContact || false}
                  onChange={e => setForm(f => ({...f, showJoviPlanetContact: !f.showJoviPlanetContact}))}
                  style={{width:22,height:22}}
                />
                <span className={styles['slider']}></span>
              </label>
              <span style={{fontSize: '1rem'}}>Este contacto é diferente daquele referido acima</span>
            </div>
            {form.showJoviPlanetContact && (
              <div className={styles['form-group']}>
                <label>E-mail para notificações de pagamento</label>
                <input type="email" name="joviPlanetContactEmail" className={styles['form-input']} value={form.joviPlanetContactEmail || ''} onChange={handleChange} />
              </div>
            )}
          </div>

          <div style={{margin:'32px 0 0 0', padding:'24px', background:'#f7f9fa', borderRadius:8, border:'1px solid #e0e0e0'}}>
            <div style={{marginBottom:18, color:'#222', fontSize:15}}>
              Ao clicar no botão Registar, aceito os <a href="/termos" target="_blank" rel="noopener noreferrer" style={{color:'#2a4b8d', textDecoration:'underline'}}>Termos e Condições</a>.
            </div>
            <div style={{marginBottom:18, color:'#444', fontSize:14}}>
              Reconheço que a JoviPlanet procede ao tratamento dos meus dados pessoais de acordo com a <a href="/privacidade" target="_blank" rel="noopener noreferrer" style={{color:'#2a4b8d', textDecoration:'underline'}}>Política de Privacidade</a> e <a href="/cookies" target="_blank" rel="noopener noreferrer" style={{color:'#2a4b8d', textDecoration:'underline'}}>Política de Cookies e Tecnologias Similares</a>.
            </div>
            <div style={{marginBottom:18, color:'#444', fontSize:14}}>
              A JoviPlanet utiliza sistemas automatizados e parceiros para analisar como utiliza os serviços para garantir a funcionalidade adequada do produto, conteúdo, publicidade personalizada e baseada em interesses, bem como proteção contra spam, malware e uso não autorizado dos serviços.
            </div>
            <label style={{display:'flex',alignItems:'flex-start',gap:12,marginBottom:18}}>
              <input
                type="checkbox"
                name="termoecondicoesUSUARIO"
                checked={form.termoecondicoesUSUARIO}
                onChange={handleChange}
                required
                style={{width:22,height:22,marginTop:2}}
              />
              <span style={{fontSize:14, color:'#444', lineHeight:1.5}}>
                Concordo com a utilização de meios de comunicação eletrónica e equipamentos terminais de telecomunicações pela JoviPlanet com a finalidade de me serem enviadas informações comerciais e realizadas ações de marketing (ex.: newsletter, mensagens SMS) por aquela, por entidades relacionadas e/ou parceiros comerciais. Meu consentimento inclui números de telefone e endereços de e-mail por mim disponibilizados na utilização dos serviços da JoviPlanet. O consentimento prestado pode ser retirado ou limitado a qualquer momento usando as configurações apropriadas da conta ou mediante pedido efetuado à JoviPlanet.
              </span>
            </label>
            <div style={{marginTop:12, color:'#444', fontSize:13}}>
              Lembramos que a aceitação dos Termos e Condições do Serviço é equivalente à celebração de um contrato.
            </div>
          </div>
          <div className={styles['info-box']} style={{background:'#e5f7ea',color:'#246c3c'}}>
            Preocupamo-nos com o meio ambiente, por isso só emitimos faturas em formato eletrónico. Receberá um e-mail sempre que uma nova fatura estiver disponível na sua conta.
            </div>
        <button type="submit" className={styles['submit-button']} disabled={loading}>{loading ? 'Enviando...' : 'Registar'}</button>
      </form>
    </div>
  );
};

export default EmpreendimentoForm;
